import formulario from "../formulario";
var contacto = function (dataLayer) {
    formulario('.piePrincipal-newsletter form', dataLayer);
};
export default contacto;
